export default __webpack_public_path__ + "static/media/recruit_table_icon_2.612a640a.svg";